export default {
    URL: "https://socket.gendermadad.uz",
    // URL: "http://localhost:3003"
}
